import axios, { AxiosRequestConfig } from 'axios'
import { stringify } from 'qs'
import { getWhoAmI } from '../common/auth/authActions'
import { store } from '../index'
import apiUrl from './apiUrl'

const ApiClient = axios.create({
  baseURL: apiUrl('/rpc'),
  paramsSerializer: (params) => stringify(params, { arrayFormat: 'repeat' }),
  timeout: 100000,
  // Use cookie based auth for web, and token based auth for native (ios, android).
  //withCredentials: !isNative(),
  withCredentials: true,
})

/*if (isNative()) {
  ApiClient.interceptors.request.use(
    async (config: AxiosRequestConfig) => {
      let { value: sessionToken } = await Preferences.get({ key: 'sessionToken' })

      if (sessionToken) {
        if (!config.headers) config.headers = {}
        if (sessionToken) config.headers['Authorization'] = `Bearer ${sessionToken}`
      }

      return config
    },
    (error) => Promise.reject(error),
  )
} else {*/
ApiClient.interceptors.request.use(
  async (config) => config,
  (error) => Promise.reject(error),
)
//}

ApiClient.interceptors.response.use(
  (response) => {
    /**
     * If response header has 'content-disposition' return full response with headers.
     * 'content-disposition' is only returned on file download.
     */
    const contentDisposition = response.headers && response.headers['content-disposition']
    if (contentDisposition) {
      return response
    }

    return response.data
  },
  (error) => {
    const { response } = error
    const { data } = response || { data: { message: 'No message has been provided by the server' } }
    const { message } = data || { message: 'No message has been provided by the server' }
    console.log('RequestFailed', message)

    const UNAUTHORIZED_ACTION = 'Unauthorized action'
    if (message === UNAUTHORIZED_ACTION) {
      store.dispatch(getWhoAmI())
    }

    // Needed for proper messages to clients
    return Promise.reject({ error: error, message: message, status: response ? response.status : -1 })
  },
)

export default ApiClient
